import store from 'store2';

export default store.namespace('@oneflow/pimienta-admin-ui');
